export default "__VITE_ASSET__D$Os6dXp__"